"use client"
import React from 'react'

export default function SkipLink(){
  return (
    <a
      href="#main"
      className="skip-link"
      onFocus={(e)=>{e.currentTarget.classList.add('skip-link--visible');}}
      onBlur={(e)=>{e.currentTarget.classList.remove('skip-link--visible');}}
    >
      Skip to content
    </a>
  )
}
